import { BootstrapLayout } from "@rpforms/shared/build/components/BootstrapLayout";
import { SchemaBuilder } from "@rpforms/shared/build/spec/SchemaBuilder";
import React, { useEffect } from "react";
import styled from "styled-components";
import { PDFPresenter } from "../PDFPresenter";

const PDFWrapper = styled.div`
    iframe {
        height: 1200px;
        margin-top: -40px;
        margin-left: -20px;
        margin-bottom: -25px;
        width: calc(100% + 40px);
        border: none;
    }
`;

const ViewPdfEntry = ({ entry, form, isPrinting }: any) => {
    useEffect(() => {
        if (!entry || !form) {
            return;
        }

        let settled = false;
        const markReady = () => {
            if (!settled) {
                settled = true;
                (window as any).PDF_READY = true;
            }
        };

        const cap = setTimeout(markReady, 10000);
        const pending = Array.from(document.images).filter((image) => !image.complete);

        const fonts = (document as any).fonts ? (document as any).fonts.ready : Promise.resolve();

        Promise.all([
            fonts,
            ...pending.map(
                (image) =>
                    new Promise((resolve) => {
                        image.addEventListener("load", resolve, { once: true });
                        image.addEventListener("error", resolve, { once: true });
                    })
            ),
        ]).then(() => requestAnimationFrame(() => requestAnimationFrame(markReady)));

        return () => clearTimeout(cap);
    }, [entry, form]);

    const schemaBuilder = new SchemaBuilder();
    const rawFormData = entry.latest_revision?.form_data || entry.form_revision?.form_data;
    const formData =
        typeof rawFormData === "string" ? JSON.parse(rawFormData || "{}") : rawFormData || {};
    const normalizedEntry = {
        ...entry,
        form_data:
            typeof entry.form_data === "string"
                ? JSON.parse(entry.form_data || "{}")
                : entry.form_data || {},
    };
    schemaBuilder.use(formData);
    schemaBuilder.dataPresenter(normalizedEntry);

    return (
        <>
            <PDFPresenter
                layout={BootstrapLayout}
                schema={schemaBuilder}
                form={form}
                saveState={normalizedEntry.form_data}
                isPrinting={isPrinting}
            />
        </>
    );
};

export default ViewPdfEntry;
